'use client';

import { Box } from '@instamenu/ui-system-next';
import { UserMenu } from '../user-menu/user-menu';
import { CartButton } from '../cart-menu/cart-button';
import { navBarContainer, navbarStyles } from './navbar.css';
import { NavbarTable } from './navbar-table';
import { useNavbarVisibility } from '@instamenu/react-hooks';
import { useUIStateContext } from '../ui-state-context/ui-state-context';
import { AddressSelect } from '../address-select/address-select';
import { LoyaltyNavBadge } from './loyalty-nav-badge';
import { themeVars } from '@instamenu/ui-vanilla-extract';

export const Navbar = () => {
  const { hideHeaderRef } = useUIStateContext();
  const isHidden = useNavbarVisibility(hideHeaderRef, 30);
  return (
    <div className={navBarContainer} style={{ top: isHidden ? '-100px' : '0' }}>
      <div className={navbarStyles}>
        <Box>
          <AddressSelect buttonProps={{ style: { height: themeVars.sizes.inputHeight.sm } }} />
          <NavbarTable />
        </Box>
        <Box
          css={{ display: 'flex', gap: 20, justifyContent: 'space-around', alignItems: 'center' }}
        >
          <LoyaltyNavBadge />
          <CartButton />
          <UserMenu />
        </Box>
      </div>
    </div>
  );
};
